module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-4-zoom.06f60e2e.png";